var $6835949b68a1fabf$exports = {};
$6835949b68a1fabf$exports = {
    "close": `\u{5E1}\u{5D2}\u{5D5}\u{5E8}`,
    "notifications": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D5}\u{5EA}`
};


export {$6835949b68a1fabf$exports as default};
//# sourceMappingURL=he-IL.module.js.map
